/**  Arrow SVG imported:
 *   https://img.icons8.com/?size=100&id=39792&format=png&color=FFFFFF  **/

/***************/
/**  IMPORTS  **/
/***************/
import { useEffect, useState, useMemo } from "react";
import { Col } from "react-bootstrap";
import { useQuery } from 'react-query';
import Cookies from "universal-cookie";
import { ring } from 'ldrs';

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../../amplifyconfiguration.json';
import { get } from 'aws-amplify/api';

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import { useAddresses } from "../../utils/LocationsContext";
import StreetBlock from "../map_components/StreetBlock";
import arrow from "../../assets/arrow.png"
import circle_plus from "../../assets/circle_plus.svg";
import { MyRow, 
         MyContainer, 
         HorizontalStreet, 
         AvailableBar, 
         NotAvailableBar, 
         TemporarilyClosedBar,
         AllBar, 
         LocCol1,
         LocRow1,
         Search,
         ScrollButton } from "../../styles/MapStyles";


/**
 * This component is responsible for displaying only the map
 * @returns The Map
 */
const Lombard = ({flipped, setFlipped, modalChange, setModalChange, allLocations, dataLoading, setDataLoading}) => {
    const [filteredValue, setFilteredValue] = useState("");
    const [upClicked, setUpClicked] = useState("");
    const [searchClicked, setSearchClicked] = useState(false);
    const [highlightClicked, setHighlightClicked] = useState(true);
    const [visible, setVisible] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [userData, setUserData] = useState(null);
    const [groupedAddresses, setGroupedAddresses] = useState({});
    const [unavailablePercent, setUnavailablePercent] = useState(null);
    const [availablePercent, setAvailablePercent] = useState(null);
    const [tempclosedPercent, setTempclosedPercent] = useState(null);
    // const [forSalePercent, setForSalePercent] = useState(null);
    const between = {};
    const parks = {"After 1602": "Residential", "Before 1611":"Residential", "After 1611": "Residential","After 1651":"Residential", "After 1674": "Residential", "After 1700": "Residential", "After 2001": "Residential", "Before 2395": "Residential", "2501": "Residential", "2600": "Residential", "2700": "Residential"};
    /**  HANDLES GETTING ALL LOCATION DATA  **/
    const { addresses } = useAddresses();

    const cookies = new Cookies();
    const token = cookies.get("TOKEN");
    const email = localStorage.getItem("EMAIL");
    const streetname = "Lombard St";
    
    Amplify.configure(amplifyconfig);
    ring.register();

    useEffect(() => {
        setFlipped(false);
    }, []);

    useEffect(() => {
        if (!Array.isArray(addresses?.data?.addresses) || addresses.data.addresses.length === 0) {
            setDataLoading(true);
        }
        handleDataUpdate();
    }, [addresses?.data?.addresses])

    const handleDataUpdate = async () => {
        await addresses.refetch();
    };

    async function getUserDetails(){
        try{
            const email = localStorage.getItem("EMAIL");
            const account = get({
                apiName: 'UserAPI',
                    path: `/user/get-user-info?email=${encodeURIComponent(email)}`,
                    options: {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    }
            });
    
            const { body } = await account.response;
            const res = await body.json();
            console.log("User details GET call succeeded");
            console.log(res);
            return res;
        } catch(e){
            console.log('User details GET call failed: ', e);
        }
      }

    useEffect(() => {
        if(userData === null){
            fetchData();
        }
    }, [userData]);

    const fetchData = async () => {
        const results = await getUserDetails();
        setUserData(results);
    }

    /**
     * This function is responsible for handling the onChange event for
     * the input field to search for locations
     * @param { Event } e 
     */
    const handleFilterChange = (e) => {
        setFilteredValue(e.target.value);
    }

    /**
     * This function is responsible for handling the onClick event for
     * the input button to search for locations
     * @param { Event } e 
     */
    const handleFilterChange2 = (e) => {
        if (filteredValue && filteredLocations.length > 0 && filteredLocations.length < 10) {
            setSearchClicked(true);
            setHighlightClicked(false);
            setFilteredValue("");
        }
    }

    /**
     * This function is responsible for handling the onKeyDown event for
     * the input field to search for locations
     * @param { Event } e 
     */
    const handleFilterChange3 = (e) => {
        if (e.key === "Enter" && filteredValue && filteredLocations.length > 0 && filteredLocations.length < 10) {
            setSearchClicked(true);
            setHighlightClicked(false);
            setFilteredValue("");
        }
    }

    /**
     * This useMeme Hook is responsible for dynamically updating the list of 
     * filtered values
     */
    const filteredLocations = useMemo(() => {
        if(allLocations && filteredValue) {
            return allLocations.filter(location => location.address.toLowerCase().includes(filteredValue.toLowerCase()) ||
                                                   location.name.toLowerCase().includes(filteredValue.toLowerCase()));
        }
    }, [allLocations, filteredValue]);

    // Check if user scrolled
    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop || document.body.scrollTop;
        setVisible(scrolled > 300);
    }

    // Scroll back to the top of the page
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.body.style.overflow = 'unset';
        setSearchClicked(false);
        setUpClicked(true);
    }

    // Create Event Listener for checking if user scrolled
    useEffect(() => {
        window.addEventListener('scroll', toggleVisible);
        return () => window.removeEventListener('scroll', toggleVisible);
    }, []);

    useEffect(() => {
        const addressList = Array.isArray(addresses?.data?.addresses) ? addresses?.data?.addresses : [];
        const grouped = {};
        const allNumbers = [];
    
        // Step 1: Group addresses by hundreds and by odds/evens
        addressList.forEach(addressObj => {
            const buildingNumber = parseInt(addressObj.address.split(" ")[0], 10);
            if (isNaN(buildingNumber)) return; // guard clause
            allNumbers.push(buildingNumber);
    
            const hundredGroup = Math.floor(buildingNumber / 100) * 100;
            const isEven = buildingNumber % 2 === 0;
            const groupKey = isEven ? "evens" : "odds";
    
            if (!grouped[hundredGroup]) {
                grouped[hundredGroup] = { odds: [], evens: [] };
            }
    
            grouped[hundredGroup][groupKey].push(addressObj);
        });
    
        // Step 2: Sort addresses in ascending order within each group
        Object.keys(grouped).forEach(hundred => {
            grouped[hundred].odds.sort((a, b) => {
                const numA = parseInt(a.address.split(" ")[0], 10);
                const numB = parseInt(b.address.split(" ")[0], 10);
                return numA - numB;
            });
    
            grouped[hundred].evens.sort((a, b) => {
                const numA = parseInt(a.address.split(" ")[0], 10);
                const numB = parseInt(b.address.split(" ")[0], 10);
                return numA - numB;
            });
        });
    
        // Step 3: Fill in any missing hundred groups
        if (allNumbers.length > 0) {
            const minGroup = Math.floor(Math.min(...allNumbers) / 100) * 100;
            const maxGroup = Math.floor(Math.max(...allNumbers) / 100) * 100;
    
            for (let group = minGroup; group <= maxGroup; group += 100) {
                if (!grouped[group]) {
                    grouped[group] = { odds: [], evens: [] };
                }
            }
        }
    
        // Step 4: Set the grouped data
        setGroupedAddresses(grouped);
        console.log(grouped)
    
        // Step 5: Set the percentage stats
        const totalDocs = addresses?.data?.totalDocs || 0;
    
        setUnavailablePercent(
            totalDocs > 0 ? parseFloat(((addresses?.data?.opNum / totalDocs) * 100).toFixed(1)) : 0
        );
        setAvailablePercent(
            totalDocs > 0 ? parseFloat(((addresses?.data?.notOpDocs / totalDocs) * 100).toFixed(1)) : 0
        );
        setTempclosedPercent(
            totalDocs > 0 ? parseFloat(((addresses?.data?.temporarilyClosed / totalDocs) * 100).toFixed(1)) : 0
        );
        // setForSalePercent(
        //     totalDocs > 0 ? parseFloat((((addresses?.data?.forSale ? addresses?.data?.forSale : 0) / totalDocs) * 100).toFixed(1)) : 0
        // );
    }, [addresses?.data?.addresses]);

    /**  SAVES SCROLL POSITION  **/
    window.addEventListener('beforeunload', () => {
        localStorage.setItem('scrollY', window.scrollY);
    });

    // Props
    const locationBarProps = {
        setSearchClicked: setSearchClicked,
        searchClicked:searchClicked,
        highlightClicked: highlightClicked,
        setHighlightClicked: setHighlightClicked,
        setModalOpen: setModalOpen,
        modalOpen: modalOpen,
        upClicked: upClicked,
        setUpClicked: setUpClicked,
        modalChange: modalChange,
        setModalChange: setModalChange,
        userData: userData,
        getUserDetails: getUserDetails,
        onUpdate: handleDataUpdate,
        parks: parks,
    }
    return (
    <>
        { dataLoading ? (
            <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
                <l-ring
                    size="50"
                    stroke="5"
                    bg-opacity="0"
                    speed="2"
                    color="#616161"
                    style={{marginTop: "30px"}} />
            </div>
        ) : (
            <>
                { !modalOpen ? <ScrollButton onClick={scrollToTop}
                                    style={{display: visible ? 'inline' : 'none'}}>
                                        <img className="arrow" 
                                            src={arrow} 
                                            alt="arrow" 
                                            style={{color: "white", height: "20px"}}/>
                                </ScrollButton> :
                                <></>}
                <MyRow className="block">
                    <LocCol1 xl={11} lg={11} style={{marginBottom: 5, height: "auto"}}>
                            <LocRow1 style={{backgroundColor: '#FAFAFA', boxShadow: '0 10px 100px -10px #E3E3E3', borderRadius: '5px', height: 'auto', justifyContent: "center", padding: "10px 0px"}}>
                                { addresses.data ? (
                                    <>
                                        <LocCol1 xl={2} lg={12} style={{top: '25%', padding: "5px", justifyContent: 'center', display: "flex"}}>
                                            <LocRow1 style={{marginTop: '-3px'}}>
                                                {addresses.data.totalDocs}<div style={{width:"15px", height: "15px", marginLeft: -5, marginTop: -8}}><AllBar /></div> &nbsp; Total Spaces
                                            </LocRow1>
                                        </LocCol1>
                                        <LocCol1 xl={2} lg={12} style={{ top: '25%', padding: "5px", marginLeft: 0, justifyContent: 'center', display: "flex"}}>
                                            <LocRow1 style={{marginTop: '-3px'}}>
                                                ({unavailablePercent}%) {addresses.data.opNum}<div style={{width:"15px", height: "15px", marginLeft: -5, marginTop: -4}}><NotAvailableBar /></div> &nbsp; Unavailable Spaces
                                            </LocRow1>
                                        </LocCol1>
                                        <LocCol1 xl={2} lg={12} style={{ top: '25%', padding: "5px", marginLeft: 0, justifyContent: 'center', display: "flex"}}>
                                            <LocRow1 style={{marginTop: '-3px'}}>
                                                ({availablePercent}%) {addresses.data.notOpDocs}<div style={{width:"15px", height: "15px", marginLeft: -5, marginTop: -4}}><AvailableBar /></div> &nbsp; Available Spaces
                                            </LocRow1>
                                        </LocCol1>
                                        <LocCol1 xl={2} lg={12} style={{ top: '25%', padding: "5px", marginLeft: 0, justifyContent: 'center', display: "flex"}}>
                                            <LocRow1 style={{marginTop: '-3px'}}>
                                                ({tempclosedPercent}%) {addresses.data.temporarilyClosed}<div style={{width:"15px", height: "15px", marginLeft: -5, marginTop: -4}}><TemporarilyClosedBar /></div> &nbsp; Temporarily Closed
                                            </LocRow1>
                                        </LocCol1>
                                        {/* <LocCol1 xl={2} lg={12} style={{ top: '25%', padding: "5px", marginLeft: 0, justifyContent: 'center', display: "flex"}}>
                                            <LocRow1 style={{marginTop: '-3px'}}>
                                                ({forSalePercent}%) {addresses.data.forSale ? addresses.data.forSale : 0}<div style={{width:"15px", height: "15px", marginLeft: -5, marginTop: -4}}><TemporarilyClosedBar style={{backgroundColor: "#44a8fb"}} /></div> &nbsp; Buildings For Sale
                                            </LocRow1>
                                        </LocCol1> */}
                                    </>
                                ) : (
                                    <></>
                                )}  
                            </LocRow1>
                            <LocRow1 style={{flexWrap: "wrap", height: "24px", marginTop: 0}}>
                                <Col style= {{fontSize: "12px"}}>
                                <img src={circle_plus} alt="circle_plus" style={{height: "18px"}}></img> = new comments on spaces
                                </Col>
                            </LocRow1>
                    </LocCol1>
                    <LocCol1 xl={6} lg={8} md={8} sm={8} xs={8} style={{marginTop: "10px", justifyContent: "center"}}>
                        <input
                            type="text"
                            value={filteredValue}
                            onChange={handleFilterChange}
                            onKeyDown={handleFilterChange3}
                            placeholder='Type to search'
                            style={{border: 'none', borderRadius: "5px", height: "50px", padding: '10px', boxShadow: "0 3px 10px 1px #E3E3E3", marginBottom: "10px", width: "97%", backgroundColor: '#FAFAFA', fontSize: '16px'}}
                        />
                    </LocCol1>
                    <LocCol1 sx={6} lg={4} md={4} sm={4} xs={4} style={{marginTop: "10px", marginBottom: "10px", width: "50px", justifyContent: "center"}}>
                        <Search 
                        onClick={handleFilterChange2}
                        type="button"> Search </Search>
                    </LocCol1>
                </MyRow>
                <MyContainer style={{marginBottom: '10px'}}>
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            GOUGH STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["1600"]} 
                        building={"1600"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            OCTAVIA STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["1700"]} 
                        building={"1700"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            LAGUNA STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["1800"]} 
                        building={"1800"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            BUCHANAN STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["1900"]} 
                        building={"1900"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            WEBSTER STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["2000"]} 
                        building={"2000"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            FILLMORE STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["2100"]} 
                        building={"2100"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            STEINER STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["2200"]} 
                        building={"2200"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            PIERCE STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["2300"]} 
                        building={"2300"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            SCOTT STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["2400"]} 
                        building={"2400"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            DIVISADERO STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["2500"]} 
                        building={"2500"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            BRODERICK STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["2600"]} 
                        building={"2600"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            BAKER STREET
                        </HorizontalStreet>
                    </MyRow>
                    <StreetBlock 
                        formattedAddress={groupedAddresses["2700"]} 
                        building={"2700"}
                        locationBarProps={locationBarProps}
                        filteredLocations={filteredLocations}
                        addresses={addresses}
                        streetname={streetname} />
                    <MyRow>
                        <HorizontalStreet
                            style={{
                                letterSpacing: "10px"
                            }}>
                            LYON STREET
                        </HorizontalStreet>
                    </MyRow>
                </MyContainer>
            </>
        )}
    </>)
}

export default Lombard;